(function () {
function init(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = '1';

  function list(key) {
    return (root.dataset[key] || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  var data = {
    titles: list('whimsyTitles'),
    adjectives: list('whimsyAdjectives'),
    nouns: list('whimsyNouns'),
    whimsyNames: list('whimsyNames'),
    human: list('human'),
    spooky: list('spooky'),
    foodie: list('foodie'),
    cute: list('cute')
  };
  var messages = (root.dataset.messages || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean);
  if (!messages.length) messages = ['Welcome to the Society, {name}!'];

  function whimsy() {
    var roll = Math.random();
    if (roll < 0.4 && data.titles.length && data.nouns.length) return pick(data.titles) + ' ' + pick(data.nouns);
    if (roll < 0.75 && data.adjectives.length && data.nouns.length) return pick(data.adjectives) + ' ' + pick(data.nouns);
    if (data.whimsyNames.length) return pick(data.whimsyNames);
    return pick(data.nouns.length ? data.nouns : ['Beans']);
  }

  function generate(vibe) {
    if (vibe === 'any') vibe = pick(['whimsy', 'cute', 'human', 'spooky', 'foodie']);
    if (vibe === 'whimsy') return whimsy();
    var source = data[vibe];
    return source && source.length ? pick(source) : whimsy();
  }

  var nameEl = root.querySelector('[data-sng-name]');
  var msgEl = root.querySelector('[data-sng-msg]');
  var resultEl = root.querySelector('[data-sng-result]');
  var confettiEl = root.querySelector('[data-sng-confetti]');
  var statusEl = root.querySelector('[data-sng-status]');
  var shareLabel = root.querySelector('[data-sng-share-label]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastName = '';
  var recent = [];
  var colors = ['#B9A0E3', '#CDB9EE', '#7E5DB8', '#9E3D6B', '#EDE4F8', '#9C80D2'];

  if (!navigator.share) shareLabel.textContent = 'Copy name';

  function confetti() {
    if (reduceMotion) return;
    confettiEl.innerHTML = '';
    for (var i = 0; i < 26; i++) {
      var bit = document.createElement('i');
      bit.style.left = (5 + Math.random() * 90) + '%';
      bit.style.background = pick(colors);
      bit.style.animationDelay = (Math.random() * 0.25) + 's';
      bit.style.setProperty('--dx', (Math.random() * 120 - 60) + 'px');
      bit.style.setProperty('--rot', (Math.random() * 540 - 270) + 'deg');
      if (Math.random() < 0.4) { bit.style.borderRadius = '50%'; bit.style.height = '9px'; }
      confettiEl.appendChild(bit);
    }
  }

  function roll() {
    var checked = root.querySelector('input[type="radio"]:checked');
    var vibe = checked ? checked.value : 'whimsy';
    var name = generate(vibe);
    for (var tries = 0; recent.indexOf(name) > -1 && tries < 40; tries++) name = generate(vibe);
    recent.push(name);
    if (recent.length > 40) recent.shift();
    lastName = name;

    nameEl.textContent = name;
    msgEl.textContent = pick(messages).replace(/\{name\}/g, name);
    statusEl.textContent = '';
    resultEl.hidden = false;

    nameEl.classList.remove('is-pop');
    void nameEl.offsetWidth;
    nameEl.classList.add('is-pop');
    confetti();
  }

  function share() {
    var text = 'My jumping spider\'s new name is ' + lastName + '! Found it at Spood Society.';
    if (navigator.share) {
      navigator.share({ title: 'My Spood Name', text: text, url: window.location.href }).catch(function () {});
      return;
    }
    var done = function () { statusEl.textContent = 'Copied! Paste it anywhere.'; };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { statusEl.textContent = lastName; });
    } else {
      statusEl.textContent = lastName;
    }
  }

  root.querySelector('[data-sng-generate]').addEventListener('click', function () {
    roll();
    if (!reduceMotion) resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });
  root.querySelector('[data-sng-again]').addEventListener('click', roll);
  root.querySelector('[data-sng-share]').addEventListener('click', share);
  }
  function all() { document.querySelectorAll('.sng').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', all); } else { all(); }
  document.addEventListener('shopify:section:load', all);
})();